'use client';
import PropTypes from 'prop-types';
import {useFormContext} from 'react-hook-form';
import {IconX} from '@tabler/icons-react';
import {Button, FormHelperText, Grid} from '@mui/material';
import {RHFMultilingualField} from '@/shared/components/forms/theme-elements/form/RHFMultilingualField';

export const Countries = ({name, values, errors}) => {
  const {setValue} = useFormContext();

  const removeCountry = (index) => {
    setValue(
      name,
      (values || []).filter((_, ind) => ind !== index)
    );
  };

  const addCountry = () =>
    setValue(name, [
      ...(values || []),
      {
        en: '',
        nl: '',
      },
    ]);

  return (
    <Grid mt={2}>
      {values?.map((country, index) => {
        return (
          <Grid
            key={country.id || `country-${index}`}
            display={'flex'}
            flexWrap={'wrap'}
            spacing={1}
            container
          >
            <Grid item md={10}>
              <RHFMultilingualField name={`${name}[${index}]`} />
            </Grid>

            <Grid item md={2}>
              <Button
                color='error'
                fontWeight={600}
                textAlign={'right'}
                sx={{
                  float: 'right',
                  height: '67%',
                  cursor: 'pointer !important',
                }}
                onClick={() => removeCountry(index)}
              >
                <IconX />
              </Button>
            </Grid>
          </Grid>
        );
      })}

      <center>
        <Button size='small' color={'error'} onClick={() => addCountry()}>
          Add New Country
        </Button>
      </center>

      {errors && (
        <FormHelperText sx={{color: 'error.main', ml: -0.01, mb: 1}}>
          {errors?.message}
        </FormHelperText>
      )}
    </Grid>
  );
};

Countries.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.array,
  errors: PropTypes.object,
};
